export default {
  "welcome": {
    "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Willkommen!"])},
    "text": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Welcome!\nGet ready to create your first Blockchain based Universal Profile!"])}
  },
  "transaction": {
    "details": {
      "activity_log": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktivitätsprotokoll"])}
    }
  },
  "settings": {
    "network": {
      "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Netzwerk"])}
    },
    "language": {
      "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sprache"])},
      "option": {
        "pl-PL": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Polnisch"])},
        "en-US": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Englisch"])},
        "de-DE": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Deutsch"])}
      }
    },
    "header": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Einstellungen"])}
  },
  "profile": {
    "empty": {
      "description": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Lorem (placeholder for now)"])}
    }
  },
  "confirmation": {
    "key_usage": {
      "transaction_fee_to_balance_separator": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([" von "])},
      "progress_label": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize([_interpolate(_named("estimatedGas")), " von ", _interpolate(_named("balance"))])}
    }
  },
  "backend": {
    "unlock": {
      "incorrect_password": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Falsches Passwort"])}
    }
  },
  "authenticate": {
    "unlock": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Freischalten"])}
  }
}